/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-03-04 15:37:23                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-04 15:52:53                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Services
  * AdminLanguagesTab: Admin languages tab
*/

/* Imports */
import { useCallback, useEffect, useState } from "react";
/***/

/* Services */
import Loading from "../../../../../../components/loading/Loading";
import { Table } from "../../../../../../components/table/Table";
import LanguageListItem from "../../../../../../components/data/language/LanguageListItem";
import { createListQuery, searchWithFilters } from "../../../../../../services/api/search";
import LanguageForm, { LanguageFormValidator } from "../../../../../../components/data/language/LanguageForm";
import { validator } from "../../../../../../services/form-validator/form-validator";
import { api } from "../../../../../../services/api/api";
import toast from "react-hot-toast";
import { showApiErrorToast } from "../../../../../../services/api/error";
import EditCreateDrawer from "../../../../../../components/edit-create-drawer/EditCreateDrawer";
/***/

/**
* AdminLanguagesTab: Admin languages tab
*/
export default function AdminLanguagesTab() {
  const [languages, setLanguages] = useState<EasyTech.Language[] | null>(null);

  const TABLE_HEAD = [
    {
      label: "name",
      orderKey: "name"
    }, {
      label: "ISO Code",
      orderKey: "isoCode"
    }, {
      label: "default",
      orderKey: null
    }, {
      label: "enabled",
      orderKey: null
    }, {
      label: "actions",
      orderKey: null
    }
  ];
  
  /**
  * updateTechnician: update technician information
  * @param tech - technician data to update
  */
  const createLanguage = (lang: EasyTech.Language): Promise<void> => {
    return new Promise((resolve, reject) => {
      const isDef = Boolean(lang.default ?? lang.isDefault);
      const payload: EasyTech.Language = {
        ...lang,
        default: isDef,
        isDefault: isDef,
        enabled: lang.enabled ?? true
      };
      if (validator.isFormValid(payload, LanguageFormValidator)) {
        api.post("admin/languages", payload).then((ret) => {
          loadLanguages();
          toast.success("Language updated");
          return resolve();
        }).catch((error) => {
          console.error(error);
          showApiErrorToast(error, { fallbackMessage: "Erreur lors de la création de la langue" });
          return reject();
        });
      } else {
        toast.error("Form is invalid");
        return reject();
      }
    });
  };
  /***/

  const loadLanguages = useCallback(() => {
    searchWithFilters<EasyTech.Language>("languages", {
      queries: [createListQuery("enabled", [true, false], "IN")]
    }, true, true)
      .then(ret => setLanguages(ret.data as EasyTech.Language[]))
      .catch(err => {
        console.error(err);
        setLanguages([]);
      });
  }, []);
  
  
  /**
  * useEffect: get languages list 
  * on init
  */
  useEffect(() => {
    loadLanguages();
  }, [loadLanguages]);
  /***/

  return (
    <div>
      <div className="icon-buttons flex gap-2">
        <EditCreateDrawer data={({default: false} as EasyTech.Language)}
                                  entityName="Language"
                                  FormComponent={LanguageForm}
                                  isNotEditable={true}
                                  onSubmit={createLanguage}
                                  createButtonText="Create new Language" />
      </div>

      <div className="my-6">
        {languages ?
          <Table  tableHead={TABLE_HEAD}
                  emptyTable={(!languages || languages.length === 0) ? "No Language" : false}>
            {languages.map((lang, index) => (
              <LanguageListItem  key={lang.id+"-"+index} language={lang} isLast={index === languages.length - 1} onChange={loadLanguages} />
            ))}
          </Table>
        : <Loading/>}
      </div>
      
    </div>
  );
}
/***/
